import { Box, IconButton, Slide } from "@mui/material";
import { makeStyles } from "@mui/styles";

interface ToastTutorialProps {
  open: boolean;
  onClose: () => void;
  children: any;
  popoverId?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    backgroundColor: theme.palette.text.primary,
    borderRadius: "16px",
    width: "300px",
  },
  content: {
    padding: "0px 24px 24px 24px",
  },
  buttons: {
    padding: "8px",
    paddingTop: "0px",
  },
  titleBar: {
    display: "flex",
    height: "36px",
    alignItems: "center",
    padding: "0px 18px",
  },
}));

export const ToastTutorial = (props: ToastTutorialProps) => {
  const classes = useStyles();

  return (
    <Slide direction="up" in={props.open} mountOnEnter unmountOnExit>
      <Box className={classes.root} id={props.popoverId} tabIndex={-1}>
        <Box className={classes.titleBar}>
          <IconButton
            aria-label="Close Additional learning popup"
            onClick={props.onClose}
            size="small"
            sx={{
              marginLeft: "auto",
              color: "#FFF",
              fontSize: "18px",
              fontWeight: 400,
              alignItems: "center",
              verticalAlign: "center",
            }}>
            <i className="fa-regular fa-close"></i>
          </IconButton>
        </Box>
        <Box className={classes.content}>{props.children}</Box>
      </Box>
    </Slide>
  );
};
